/*
 * @Author: fcg 1391295178@qq.com
 * @Date: 2024-07-04 08:35:20
 * @LastEditors: fcg 1391295178@qq.com
 * @LastEditTime: 2024-09-11 15:37:58
 * @FilePath: \HouseB\HousePcVue\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import {Message, Notification} from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '/index.php?s=',
    baseURL: 'https://yuejialianhang.com/index.php?s=',
    // baseURL: 'https://houseb.cloudthink.top/index.php?s=',
    // 超时
    timeout: 100 * 1000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要防止数据重复提交
    // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.status || 200;
        if (code === 401) {
            return Promise.reject('Connection to server failed')
        } else if (code === 500) {
            // Message({
            // 	message: '连接服务器失败',
            // 	type: 'error'
            // })
            // return Promise.reject(new Error('连接服务器失败'))
            Notification.error({
                title: res.data.msg
            })
            return Promise.reject(res.data)
        } else if (code !== 200) {
            Notification.error({
                title: 'connect failed'
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        let {
            message
        } = error;
        if (message == "Network Error") {
            message = "Abnormal backend interface connection";
        } else if (message.includes("timeout")) {
            message = "System interface request timeout";
        } else if (message.includes("Request failed with status code")) {
            message = "Interface " + message.substr(message.length - 3) + " abnormal";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
